<template>
  <div
    class="gw_table_body_cell"
    :style="tdStyle"
    v-bind="item.props || {}"
    :data-tst="`td_${thKey}`"
    @click="e => $emit('click', e)"
  >
    <slot>
      {{ item[thKey] }}
    </slot>
  </div>
</template>

<script>
export default {
  name: 'TableBodyCell',
  props: {
    thKey: [String, Number],
    item: { default: () => ({}) },
  },
  emits: ['click'],
  computed: {
    tdStyle() {
      return this.$parent?.thead?.[this.thKey]?.tdStyle || ''
    },
  },
}
</script>
